<template>
  <div class="animated fadeIn">

    <!-- TOP CARD START -->

    <b-card>
        <h1>
         Spacing
        </h1>
        <p>Our spacing is based on a 4-pixel grid, please use only these sizes:</p>        
        <br />
        <table class="table">
          <thead>
            <tr>
              <th>Size Name</th>
              <th>Value</th>
              <th>Example of use</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <p>XXS</p>
              </td>
              <td>
                <p style="font-weight: bold;">4px or 0.25rem</p>
              </td>
              <td>
                <p>Great for really small spaces like connecting an error message to form, eg.</p>
              </td>
            </tr>
            <tr>
              <td>
                <p>XS</p>
              </td>
              <td>
                <p style="font-weight: bold;">8 or 0.5rem</p>
              </td>
              <td>
                <p>Great when you need to connect related components, like a header and a description.</p>
              </td>
            </tr>
            <tr>
              <td>
                <p>S</p>
              </td>
              <td>
                <p style="font-weight: bold;">12 or 0.75rem</p>
              </td>
              <td>
                <p>-</p>
              </td>
            <tr>
              <td>
                <p>M</p>
              </td>
              <td>
                <p style="font-weight: bold;">16 or 1rem</p>
              </td>
              <td>
                <p>16	Great for inner padding, left & right padding of the screen when placing content on mobile.</p>
              </td>
            </tr>
            <tr>
               <td>
                <p>L</p>
              </td>
              <td>
                <p style="font-weight: bold;">24 or 1.5rem</p>
              </td>
              <td>
                <p>	Default for spacing, for left & right inner padding in sections.</p>
              </td>
            </tr>
            <tr>
               <td>
                <p>XL</p>
              </td>
              <td>
                <p style="font-weight: bold;">32  or 2rem</p>
              </td>
              <td>
                <p>	-</p>
              </td>
            </tr>
            <tr>
               <td>
                <p>XXL</p>
              </td>
              <td>
                <p style="font-weight: bold;">48  or 3rem</p>
              </td>
              <td>
                <p>	-</p>
              </td>
            </tr>
            <tr>
               <td>
                <p>XXXL</p>
              </td>
              <td>
                <p style="font-weight: bold;">80 or 5rem</p>
              </td>
              <td>
                <p>	Great for space between illustration and header.</p>
              </td>
            </tr>
          </tbody>
        </table>
    </b-card>

    <!-- TOP CARD END -->

    <b-card>
      <h1>
        Shadows
      </h1>
      <b-card-body>
        <b-card class="box-shadow-sm">
          box-shadow-sm
        </b-card>
        <b-card class="box-shadow-md">
          box-shadow-md
        </b-card>
        <b-card class="box-shadow-lg">
          box-shadow-lg
        </b-card>
        <b-card class="box-shadow-inset">
          box-shadow-inset
        </b-card>
      </b-card-body>
    </b-card>


    <b-card>
      <h1>
        Grid System (12 Column)
      </h1>
      <b-card-body>
        <!-- 1 Column - Stack the columns on mobile by making one full-width and the other half-width -->
        <div class="row">
          <div class="col-12 col-md-12" style="background-color: rgba(86,61,124,.15); border: 1px solid rgba(86,61,124,.2); padding: 12px; text-align: center;">1</div>
        </div>
        <br />
        <!-- 2 Columns - Columns are always 50% wide, on mobile and desktop -->
        <div class="row">
          <div class="col-6" style="background-color: rgba(86,61,124,.15); border: 1px solid rgba(86,61,124,.2); padding: 12px; text-align: center;">1</div>
          <div class="col-6" style="background-color: rgba(86,61,124,.15); border: 1px solid rgba(86,61,124,.2); padding: 12px; text-align: center;">2</div>
        </div>
        <br />
        <!-- 3 columns -->
        <div class="row">
          <div class="col-6 col-md-4" style="background-color: rgba(86,61,124,.15); border: 1px solid rgba(86,61,124,.2); padding: 12px; text-align: center;">1</div>
          <div class="col-6 col-md-4" style="background-color: rgba(86,61,124,.15); border: 1px solid rgba(86,61,124,.2); padding: 12px; text-align: center;">2</div>
          <div class="col-6 col-md-4" style="background-color: rgba(86,61,124,.15); border: 1px solid rgba(86,61,124,.2); padding: 12px; text-align: center;">3</div>
        </div>
        <br />
        <!-- 4 Columns -->
        <div class="row">
          <div class="col-6 col-md-3" style="background-color: rgba(86,61,124,.15); border: 1px solid rgba(86,61,124,.2); padding: 12px ; text-align: center;">1</div>
          <div class="col-6 col-md-3" style="background-color: rgba(86,61,124,.15); border: 1px solid rgba(86,61,124,.2); padding: 12px ; text-align: center;">2</div>
          <div class="col-6 col-md-3" style="background-color: rgba(86,61,124,.15); border: 1px solid rgba(86,61,124,.2); padding: 12px ; text-align: center;">3</div>
          <div class="col-6 col-md-3" style="background-color: rgba(86,61,124,.15); border: 1px solid rgba(86,61,124,.2); padding: 12px ; text-align: center;">4</div>
        </div>
        <br />

        <!-- 6 Columns -->
        <div class="row">
          <div class="col-6 col-md-2" style="background-color: rgba(86,61,124,.15); border: 1px solid rgba(86,61,124,.2); padding: 12px; text-align: center;">1</div>
          <div class="col-6 col-md-2" style="background-color: rgba(86,61,124,.15); border: 1px solid rgba(86,61,124,.2); padding: 12px; text-align: center;">2</div>
          <div class="col-6 col-md-2" style="background-color: rgba(86,61,124,.15); border: 1px solid rgba(86,61,124,.2); padding: 12px; text-align: center;">3</div>
          <div class="col-6 col-md-2" style="background-color: rgba(86,61,124,.15); border: 1px solid rgba(86,61,124,.2); padding: 12px; text-align: center;">4</div>
          <div class="col-6 col-md-2" style="background-color: rgba(86,61,124,.15); border: 1px solid rgba(86,61,124,.2); padding: 12px; text-align: center;">5</div>
          <div class="col-6 col-md-2" style="background-color: rgba(86,61,124,.15); border: 1px solid rgba(86,61,124,.2); padding: 12px; text-align: center;">6</div>
        </div>
        <br />

        <!-- 12 Columns -->
        <div class="row">
          <div class="col-6 col-md-1" style="background-color: rgba(86,61,124,.15); border: 1px solid rgba(86,61,124,.2); padding: 12px; text-align: center;">1</div>
          <div class="col-6 col-md-1" style="background-color: rgba(86,61,124,.15); border: 1px solid rgba(86,61,124,.2); padding: 12px; text-align: center;">2</div>
          <div class="col-6 col-md-1" style="background-color: rgba(86,61,124,.15); border: 1px solid rgba(86,61,124,.2); padding: 12px; text-align: center;">3</div>
          <div class="col-6 col-md-1" style="background-color: rgba(86,61,124,.15); border: 1px solid rgba(86,61,124,.2); padding: 12px; text-align: center;">4</div>
          <div class="col-6 col-md-1" style="background-color: rgba(86,61,124,.15); border: 1px solid rgba(86,61,124,.2); padding: 12px; text-align: center;">5</div>
          <div class="col-6 col-md-1" style="background-color: rgba(86,61,124,.15); border: 1px solid rgba(86,61,124,.2); padding: 12px; text-align: center;">6</div>
          <div class="col-6 col-md-1" style="background-color: rgba(86,61,124,.15); border: 1px solid rgba(86,61,124,.2); padding: 12px; text-align: center;">7</div>
          <div class="col-6 col-md-1" style="background-color: rgba(86,61,124,.15); border: 1px solid rgba(86,61,124,.2); padding: 12px; text-align: center;">8</div>
          <div class="col-6 col-md-1" style="background-color: rgba(86,61,124,.15); border: 1px solid rgba(86,61,124,.2); padding: 12px; text-align: center;">9</div>
          <div class="col-6 col-md-1" style="background-color: rgba(86,61,124,.15); border: 1px solid rgba(86,61,124,.2); padding: 12px; text-align: center;">10</div>
          <div class="col-6 col-md-1" style="background-color: rgba(86,61,124,.15); border: 1px solid rgba(86,61,124,.2); padding: 12px; text-align: center;">11</div>
          <div class="col-6 col-md-1" style="background-color: rgba(86,61,124,.15); border: 1px solid rgba(86,61,124,.2); padding: 12px; text-align: center;">12</div>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
export default {
  name: 'typography'
}
</script>
